module.exports = __webpack_public_path__ + "static/media/Sonakshi_Jhanwar.f6c929a7.jpg";